import { computed, watch } from 'vue';
import { useRouteMetaOverrideStore } from '@/stores/useRouteMetaOverrideStore';
import { useRoute } from 'vue-router';

const BASE_TITLE = import.meta.env.VITE_APP_TITLE || 'Patient Portal';

export interface UsePageTitleOptions {
  separator?: string;
  mode?: 'suffix' | 'prefix';
}

export function usePageTitle(options: UsePageTitleOptions = {}) {
  const metaStore = useRouteMetaOverrideStore();
  const route = useRoute();

  // NB. initial page title set in tenantRouting.ts
  const separator = options.separator ?? ' | ';
  const mode = options.mode ?? 'prefix';

  const resolvedTitle = computed(() => {
    return metaStore.pageTitle || (route.meta?.pageTitle as string | undefined) || null;
  });

  const fullTitle = computed(() => {
    const title = resolvedTitle.value;

    if (!title) return BASE_TITLE;

    return mode === 'prefix'
      ? `${BASE_TITLE}${separator}${title}`
      : `${title}${separator}${BASE_TITLE}`;
  });

  watch(
    fullTitle,
    (title) => {
      document.title = title;
    },
    { immediate: true },
  );

  return {
    fullTitle,
    resolvedTitle, // optional but useful
  };
}
